/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-lights-party block)");
/* eslint-enable no-console */

(function () {
    function init() {
        const canvas = document.getElementById('fc-canvas');
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const wrap = document.getElementById('fc-preview');
        const listEl = document.getElementById('fc-color-list');
        const addBtn = document.getElementById('fc-add-btn');
        const presetEl = document.getElementById('fc-preset');
        const modeEl = document.getElementById('fc-mode');
        const orderEl = document.getElementById('fc-order');
        const showHexEl = document.getElementById('fc-show-hex');
        const durEl = document.getElementById('fc-duration');
        const fadeDurEl = document.getElementById('fc-fade-dur');
        const toggleBtn = document.getElementById('fc-toggle');
        const resetBtn = document.getElementById('fc-reset');
        const infoEl = document.getElementById('fc-info');
        const progressEl = document.getElementById('fc-progress');
        const fsBtn = document.getElementById('fc-fs-btn');
        const fsExpand = document.getElementById('fc-fs-expand');
        const fsCompress = document.getElementById('fc-fs-compress');
        const popup = document.getElementById('fc-cp-popup');
        const cpSwatch = document.getElementById('fc-cp-swatch');
        const cpHex = document.getElementById('fc-cp-hex');
        const cpCopy = document.getElementById('fc-cp-copy');
        const cpPaste = document.getElementById('fc-cp-paste');
        const cpAdd = document.getElementById('fc-cp-add');
        const cpCancel = document.getElementById('fc-cp-cancel');

        let running = false, rafId = null;
        let cw = 0, ch = 0, dpr = 1;
        let colors = [], sequence = [], seqIdx = 0;
        let phase = 'hold', phaseT = 0, lastTs = null;
        let currentIdx = 0, nextIdx = 1;

        // ── Presets ──────────────────────────────────────────────────────
        const PRESETS = {
            sunset: ['#ff6b35', '#f7931e', '#ffcd3c', '#ff4e50', '#c0392b', '#8e44ad', '#e74c3c', '#ff8c42', '#ffc857', '#d62828'],
            ocean: ['#0077b6', '#00b4d8', '#48cae4', '#90e0ef', '#caf0f8', '#023e8a', '#0096c7', '#ade8f4', '#03045e', '#00b4d8'],
            aurora: ['#00ff88', '#00ccff', '#8844ff', '#ff44cc', '#00ffcc', '#44ff88', '#0099ff', '#ff00aa', '#00ffaa', '#6644ff'],
            fire: ['#ff0000', '#ff4500', '#ff8c00', '#ffd700', '#ff6347', '#dc143c', '#ff1493', '#ff7f00', '#ffaa00', '#cc0000'],
            forest: ['#1b4332', '#2d6a4f', '#40916c', '#52b788', '#74c69d', '#95d5b2', '#b7e4c7', '#d8f3dc', '#081c15', '#1b4332'],
            midnight: ['#0d0221', '#0a1045', '#1a1a6e', '#0d3b8e', '#0466c8', '#48cae4', '#023e8a', '#0077b6', '#00b4d8', '#3a0ca3'],
            pastel: ['#ffadad', '#ffd6a5', '#fdffb6', '#caffbf', '#9bf6ff', '#bdb2ff', '#ffc8dd', '#ffafcc', '#a2d2ff', '#cdb4db'],
            candy: ['#ff70a6', '#ff9770', '#ffd670', '#70d6ff', '#e9ff70', '#c77dff', '#ff4d6d', '#ff9f1c', '#2ec4b6', '#cbf3f0'],
            rose: ['#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7', '#ffccd5', '#ff4d6d', '#c9184a', '#590d22'],
            lavender: ['#7400b8', '#6930c3', '#5e60ce', '#5390d9', '#4ea8de', '#48bfe3', '#56cfe1', '#64dfdf', '#72efdd', '#80ffdb'],
            party: ['#ff0000', '#ff7700', '#ffff00', '#00cc00', '#0000ff', '#8800ff', '#ff00ff', '#ff0088', '#00ffff', '#ff4400'],
            neon: ['#ff00ff', '#00ffff', '#ff0066', '#00ff66', '#ff6600', '#0066ff', '#ffff00', '#ff0099', '#00ff99', '#9900ff'],
            carnival: ['#e63946', '#f4a261', '#2a9d8f', '#e9c46a', '#264653', '#f72585', '#7209b7', '#3a0ca3', '#4361ee', '#4cc9f0'],
            christmas: ['#c41e3a', '#006400', '#ffffff', '#cc0000', '#165b33', '#bb2528', '#f8b400', '#146b3a', '#ea4630', '#f7f7f7'],
            halloween: ['#ff6700', '#000000', '#7b2d8b', '#ff9a3c', '#1a1a2e', '#e94560', '#ff4500', '#6a0572', '#ff8c00', '#2d2d2d'],
            newyear: ['#ffd700', '#c0c0c0', '#b8860b', '#fffacd', '#daa520', '#f0e68c', '#ff69b4', '#ff1493', '#9400d3', '#4b0082'],
            tropical: ['#ff006e', '#fb5607', '#ffbe0b', '#8338ec', '#3a86ff', '#06d6a0', '#ef233c', '#f72585', '#4cc9f0', '#80b918'],
            pride: ['#ff0018', '#ffa52c', '#ffff41', '#008018', '#0000f9', '#86007d', '#ff0018', '#ffa52c', '#ffff41', '#008018'],
        };

        // ── Popup ─────────────────────────────────────────────────────────
        function openPopup(anchor) {
            popup.classList.add('open');
            cpSwatch.value = '#ff6b35'; cpHex.value = '#FF6B35';
            const r = anchor.getBoundingClientRect();
            const pw = popup.offsetWidth || 230, ph = popup.offsetHeight || 145, m = 8;
            let top = r.bottom + m, left = r.left;
            if (left + pw > window.innerWidth - m) left = window.innerWidth - pw - m;
            if (left < m) left = m;
            if (top + ph > window.innerHeight - m) top = r.top - ph - m;
            if (top < m) top = m;
            popup.style.top = `${top}px`; popup.style.left = `${left}px`;
            setTimeout(() => cpHex.focus(), 50);
        }
        function closePopup() { popup.classList.remove('open'); }

        document.addEventListener('click', e => {
            if (popup.classList.contains('open') && !popup.contains(e.target) && e.target !== addBtn) closePopup();
        });

        cpSwatch.addEventListener('input', () => { cpHex.value = cpSwatch.value.toUpperCase(); });
        cpHex.addEventListener('input', () => {
            let v = cpHex.value.trim();
            if (!v.startsWith('#')) v = '#' + v;
            if (/^#[0-9a-fA-F]{6}$/.test(v)) cpSwatch.value = v;
        });

        cpCopy.addEventListener('click', () => {
            navigator.clipboard.writeText(cpSwatch.value.toUpperCase())
                .then(() => { cpCopy.textContent = '✓ Copied'; setTimeout(() => cpCopy.textContent = 'Copy', 1600); })
                .catch(() => { cpHex.select(); document.execCommand('copy'); cpCopy.textContent = '✓ Copied'; setTimeout(() => cpCopy.textContent = 'Copy', 1600); });
        });

        cpPaste.addEventListener('click', async () => {
            try {
                let t = (await navigator.clipboard.readText()).trim();
                const hex = t.startsWith('#') ? t : '#' + t;
                if (/^#[0-9a-fA-F]{6}$/.test(hex)) { cpSwatch.value = hex; cpHex.value = hex.toUpperCase(); }
                else { cpPaste.textContent = '✗ Invalid'; setTimeout(() => cpPaste.textContent = 'Paste', 1600); }
            } catch { cpPaste.textContent = '✗ Error'; setTimeout(() => cpPaste.textContent = 'Paste', 1600); }
        });

        cpAdd.addEventListener('click', () => {
            let v = cpHex.value.trim();
            if (!v.startsWith('#')) v = '#' + v;
            colors.push((/^#[0-9a-fA-F]{6}$/.test(v) ? v : cpSwatch.value).toLowerCase());
            renderList(); rebuildSeq(); setCustom(); closePopup();
        });
        cpCancel.addEventListener('click', closePopup);
        addBtn.addEventListener('click', e => { e.stopPropagation(); openPopup(addBtn); });

        // ── Preset palette ────────────────────────────────────────────────
        function setCustom() {
            presetEl.querySelector('[value="custom"]').style.display = '';
            presetEl.value = 'custom';
        }
        presetEl.addEventListener('change', () => {
            if (!presetEl.value || presetEl.value === 'custom') return;
            colors = [...PRESETS[presetEl.value]];
            renderList(); rebuildSeq();
        });

        // ── Color list — does not recreate the + button ───────────────────
        function renderList() {
            listEl.querySelectorAll('.fc-chip').forEach(el => el.remove());
            colors.forEach((hex, i) => {
                const chip = document.createElement('div');
                chip.className = 'fc-chip'; chip.style.background = hex; chip.title = hex.toUpperCase();
                const rm = document.createElement('span');
                rm.className = 'fc-rm'; rm.textContent = '×';
                rm.addEventListener('click', e => {
                    e.stopPropagation();
                    if (colors.length > 2) { colors.splice(i, 1); renderList(); rebuildSeq(); setCustom(); }
                });
                chip.appendChild(rm);
                listEl.insertBefore(chip, addBtn);
            });
        }

        // ── Sequence ──────────────────────────────────────────────────────
        function rebuildSeq() {
            const n = colors.length;
            if (n < 2) { sequence = [0, 1]; currentIdx = 0; nextIdx = 1; return; }
            const ord = orderEl.value;
            if (ord === 'random') {
                sequence = Array.from({ length: Math.max(n * 3, 12) }, () => Math.floor(Math.random() * n));
            } else if (ord === 'pingpong') {
                sequence = [];
                for (let i = 0; i < n - 1; i++) sequence.push(i);
                for (let i = n - 1; i > 0; i--) sequence.push(i);
            } else {
                sequence = Array.from({ length: n }, (_, i) => i);
            }
            seqIdx = 0; currentIdx = sequence[0]; nextIdx = sequence[1 % sequence.length];
            phase = 'hold'; phaseT = 0;
        }
        orderEl.addEventListener('change', rebuildSeq);

        // ── Resize with retry ─────────────────────────────────────────────
        function resize() {
            dpr = window.devicePixelRatio || 1;
            cw = wrap.clientWidth; ch = wrap.clientHeight;
            if (!cw || !ch) { setTimeout(resize, 50); return; }
            canvas.width = Math.round(cw * dpr); canvas.height = Math.round(ch * dpr);
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }

        new ResizeObserver(() => resize()).observe(wrap);

        // ── Color utilities ───────────────────────────────────────────────
        function hexToRGB(hex) {
            return { r: parseInt(hex.slice(1, 3), 16), g: parseInt(hex.slice(3, 5), 16), b: parseInt(hex.slice(5, 7), 16) };
        }
        function rgbToHex(r, g, b) {
            return '#' + [r, g, b].map(v => Math.round(v).toString(16).padStart(2, '0')).join('');
        }

        // ── Canvas draw ───────────────────────────────────────────────────
        function drawColor(hexA, hexB, t) {
            const mode = modeEl.value;
            const cA = hexToRGB(hexA), cB = hexToRGB(hexB);
            const mix = (a, b, x) => ({ r: a.r + (b.r - a.r) * x, g: a.g + (b.g - a.g) * x, b: a.b + (b.b - a.b) * x });

            if (mode === 'solid') {
                const c = mix(cA, cB, t);
                ctx.fillStyle = `rgb(${c.r},${c.g},${c.b})`; ctx.fillRect(0, 0, cw, ch);
                return rgbToHex(c.r, c.g, c.b);
            }

            const idxA = colors.indexOf(hexA), idxB = colors.indexOf(hexB);
            const nA = colors[(idxA + 1) % colors.length], nB = colors[(idxB + 1) % colors.length];

            const makeGrad = (h1, h2) => {
                const c1 = hexToRGB(h1), c2 = hexToRGB(h2);
                let g;
                if (mode === 'gradient-h') g = ctx.createLinearGradient(0, 0, cw, 0);
                else if (mode === 'gradient-v') g = ctx.createLinearGradient(0, 0, 0, ch);
                else if (mode === 'gradient-d') g = ctx.createLinearGradient(0, 0, cw, ch);
                else g = ctx.createRadialGradient(cw / 2, ch / 2, 0, cw / 2, ch / 2, Math.max(cw, ch) * .7);
                g.addColorStop(0, `rgb(${c1.r},${c1.g},${c1.b})`);
                g.addColorStop(1, `rgb(${c2.r},${c2.g},${c2.b})`);
                ctx.fillStyle = g; ctx.fillRect(0, 0, cw, ch);
            };

            makeGrad(hexA, nA);
            ctx.globalAlpha = t; makeGrad(hexB, nB); ctx.globalAlpha = 1;
            const mid = mix(cA, cB, t);
            return rgbToHex(mid.r, mid.g, mid.b);
        }

        // ── RAF loop ──────────────────────────────────────────────────────
        function frame(ts) {
            if (!running) return;
            if (lastTs === null) lastTs = ts;
            const dt = Math.min((ts - lastTs) / 1000, 0.1); lastTs = ts;
            const holdDur = parseFloat(durEl.value), fadeDur = parseFloat(fadeDurEl.value);
            phaseT += dt;
            let fadeT = 0;

            if (phase === 'hold') {
                progressEl.style.width = `${Math.min(phaseT / holdDur * 100, 100)}%`;
                if (phaseT >= holdDur) { phase = 'fade'; phaseT = 0; }
            } else {
                fadeT = Math.min(phaseT / fadeDur, 1);
                fadeT = fadeT * fadeT * (3 - 2 * fadeT); // smooth-step
                progressEl.style.width = `${fadeT * 100}%`;
                if (phaseT >= fadeDur) {
                    seqIdx = (seqIdx + 1) % sequence.length;
                    currentIdx = sequence[seqIdx]; nextIdx = sequence[(seqIdx + 1) % sequence.length];
                    phase = 'hold'; phaseT = 0; fadeT = 0;
                    if (orderEl.value === 'random' && seqIdx >= sequence.length - 2) {
                        const n = colors.length;
                        for (let i = 0; i < n; i++) sequence.push(Math.floor(Math.random() * n));
                    }
                }
            }

            const hexA = colors[currentIdx] || '#000', hexB = colors[nextIdx] || '#000';
            const hex = drawColor(hexA, hexB, fadeT);
            infoEl.style.opacity = showHexEl.value === '1' ? '1' : '0';
            if (showHexEl.value === '1') infoEl.textContent = hex.toUpperCase();
            rafId = requestAnimationFrame(frame);
        }

        // ── Controls ──────────────────────────────────────────────────────
        function start() {
            if (running) return;
            if (colors.length < 2) { alert('Add at least 2 colors.'); return; }
            running = true; lastTs = null; toggleBtn.textContent = 'Pause';
            rafId = requestAnimationFrame(frame);
        }
        function pause() {
            running = false; if (rafId) cancelAnimationFrame(rafId);
            rafId = null; lastTs = null; toggleBtn.textContent = 'Resume';
        }
        function reset() {
            pause(); rebuildSeq(); phaseT = 0; phase = 'hold';
            progressEl.style.width = '0%';
            if (colors.length) { const c = hexToRGB(colors[0]); ctx.fillStyle = `rgb(${c.r},${c.g},${c.b})`; ctx.fillRect(0, 0, cw, ch); }
        }

        toggleBtn.addEventListener('click', () => running ? pause() : start());
        resetBtn.addEventListener('click', reset);
        durEl.addEventListener('input', () => document.getElementById('fc-dur-val').textContent = `${durEl.value}s`);
        fadeDurEl.addEventListener('input', () => document.getElementById('fc-fade-val').textContent = `${fadeDurEl.value}s`);

        fsBtn.addEventListener('click', () => {
            if (!document.fullscreenElement) wrap.requestFullscreen().catch(() => { });
            else document.exitFullscreen().catch(() => { });
        });

        document.addEventListener('fullscreenchange', () => {
            const fs = !!document.fullscreenElement;
            fsExpand.style.display = fs ? 'none' : 'block';
            fsCompress.style.display = fs ? 'block' : 'none';
            fsBtn.setAttribute('aria-label', fs ? 'Exit full screen' : 'Full screen');
            wrap.classList.toggle('fc-fullscreen', fs);
            setTimeout(resize, 30);
        });

        // ── Init — no autostart ───────────────────────────────────────────
        colors = [...PRESETS.sunset];
        presetEl.value = 'sunset';
        renderList(); resize(); rebuildSeq();
        const ic = hexToRGB(colors[0]);
        ctx.fillStyle = `rgb(${ic.r},${ic.g},${ic.b})`; ctx.fillRect(0, 0, cw, ch);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
}());
